export const RICH_TEXT_ENABLED = 'g2w-rich-text-enabled';
export const RICH_TEXT_EDITOR_DESCRIPTION = 'webinar-desc-rich-text-enabled';
export const VIRTUAL_EVENT_RICH_TEXT_ENABLED = 'virtualevent-rich-text-enabled';
export const SPEAKER_BIO_RICH_TEXT_ENABLED = 'g2w-speaker-bio-rich-text-enabled';
